<template lang="pug">
#gestao-contratos-originacao-subempresa
    BaseHeader(
        :titulo='$t("denuncia.words.title")',
        :exibeBotao='true',
        icon='el-icon-plus',
        :btnTexto='$t("denuncia.words.button.new")',
        @btnHeaderClicado='irParaInserirDenuncia'
    )

    .view-container.margen-bottom-pages
        .bloco-pesquisa-filtros
            BlocoPesquisaFiltros(@emitFiltros='adicionarFiltros')

        .bloco-novos-contratos-tabela
            Tabela(
                :tabelaData='contratosTabela',
                :carregando='carregandoTabela',
                :paginacao='paginacao',
                @mudarPagina='mudarPagina',
                @ordenarTabela='ordenarTabela'
            )
</template>

<script>
import BlocoPesquisaFiltros from '@/modules/denuncia/views/components/DenunciaBlocoPesquisaFiltros.vue';
import BaseHeader from '@/components/BaseHeader.vue';
import services from '@/modules/denuncia/services/DenunciaService';
import BlocoInformacao from '@/components/contratosOriginacao/SubEmpresaBlocoInformacao.vue';
import Tabela from '@/modules/denuncia/views/components/DenunciaTabelaGestao.vue';
import validators from '@/utils/validators';
import CarUtils from '@/utils/CarUtils';
import useShareReportInsert from '@/modules/denuncia/composition/useShareReportInsert';
import { mapGetters } from 'vuex';

export default {
    name: 'Denuncia',
    components: {
        BaseHeader,
        BlocoInformacao,
        Tabela,
        BlocoPesquisaFiltros
    },

    data() {
        return {
            contratosTabela: [],
            paginacao: {},
            params: {
                page: 0,
                size: 10,
                sort: 'idDenuncia',
                por: 'desc'
            },
            data: {
                dataInicio: null,
                dataFim: null,
                car: null,
                cpfCnpj: null,
                idDenuncia: null
            },
            carregandoTabela: false
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado', 'isAlvorada'])
    },
    mounted() {
        this.buscarDenuncias();
        const { clear } = useShareReportInsert();
        clear();
    },
    methods: {
        async buscarDenuncias() {
            this.carregandoTabela = true;
            try {
                const { data } = await services.fetchDenuncias(
                    this.params,
                    this.data
                );
                this.contratosTabela = data.itens.map(item => {
                    if (item.listaCar || item.listaCpfCnpj) {
                        const fullString = [
                            ...item.listaCar.split(','),
                            ...item.listaCpfCnpj.split(',')
                        ].join(', ');

                        return {
                            ...item,
                            listaValor: fullString
                                .trim()
                                .replace(/^,|,$/g, '')
                                .trim()
                        };
                    }
                });
                this.paginacao = data.paginacao;
            } catch (error) {
                this.$notify.error({
                    message: error
                });
            }

            this.carregandoTabela = false;
        },
        mudarPagina(novaPagina) {
            this.paginacao.pagina = novaPagina;
            this.params.page = novaPagina;
            this.buscarDenuncias();
        },
        ordenarTabela(column) {
            this.params.sort = column.prop;
            this.params.por = column.order;
            this.buscarDenuncias();
        },
        adicionarFiltros(filtro) {
            this.data.dataInicio = filtro.dataCadastroInicio;
            this.data.dataFim = filtro.dataCadastroFim;

            this.convertFiltroGeralParaEspecifico(filtro);
            const filtroTemParamentro = Object.keys(this.data).some(
                key => !this.data[key]
            );

            if (filtroTemParamentro) {
                this.paginacao.pagina = 0;
                this.page = 0;
                this.params.page = 0;
            }
            this.params = { ...this.params, ...filtro };
            this.buscarDenuncias();
        },
        convertFiltroGeralParaEspecifico(filtro) {
            const termo = filtro.pesquisa;
            const valorLimpo = termo.replace(/[^a-zA-Z0-9]/g, '');
            const cpfValido = validators.validarCpf(termo);
            const cnpjValido = validators.validarCnpj(termo);
            const carValido = CarUtils.isCar(termo);
            const cpfOuCnpjInvalido =
                !isNaN(valorLimpo[0]) &&
                (valorLimpo.length === 11 || valorLimpo.length === 14);

            if (termo.length === 0) {
                delete this.data.cpfCnpj;
                delete this.data.car;
                delete this.data.idDenuncia;
            } else if (cpfValido || cnpjValido || cpfOuCnpjInvalido) {
                this.data.cpfCnpj = termo;
                delete this.data.car;
                delete this.data.idDenuncia;
            } else if (carValido || isNaN(valorLimpo[0])) {
                this.data.car = termo;
                delete this.data.idDenuncia;
                delete this.data.cpfCnpj;
            } else {
                this.data.idDenuncia = termo;
                delete this.data.cpfCnpj;
                delete this.data.car;
            }
        },

        async showDialogConsenso() {
            const result = await this.$messageBox
                .confirm(
                    this.$t('denuncia.messages.dialog_message'),
                    this.$t('denuncia.messages.dialog_title'),
                    {
                        confirmButtonText: this.$t(
                            'denuncia.messages.dialog_confirm'
                        ),
                        cancelButtonText: this.$t(
                            'denuncia.messages.dialog_cancel'
                        )
                    }
                )
                .catch(() => {
                    this.$router.push({ name: 'Home' });
                });
            if (result === 'confirm') {
                await this.atualizarAceite();
            }
        },

        async atualizarAceite() {
            await services.atualizaDataAceitacao();
        },

        irParaInserirDenuncia() {
            this.$router.push({
                name: 'DenunciaInserir'
            });
        }
    }
};
</script>

<style lang="scss">
#gestao-contratos-originacao-subempresa {
    .bloco-infor-dados {
        display: flex;
        justify-content: space-between;
        gap: 11px;
        width: 100%;
        flex-wrap: wrap;

        & > div {
            flex-grow: 1;
        }
    }

    .bloco-novos-contratos-preenchimento,
    .bloco-infor-dados,
    .bloco-pesquisa-filtros,
    .bloco-novos-contratos-tabela {
        margin-top: 20px;
    }

    .total-contratos {
        font-size: 19px;
        margin-right: 6px;
    }
}

.alertas-contratos-interno {
    display: flex;
    align-items: center;

    span {
        font-size: 22px;
        color: #3b3b3b;
        margin-right: 10px;
    }

    .link {
        color: #3fb1f2;
        margin-left: 6px;
        cursor: pointer;
        text-decoration: underline;
    }

    .link:hover {
        color: #ddac44;
    }
}

.alertas-enter-active,
.alertas-leave-active {
    transition: opacity 0.5s;
}

.alertas-enter,
.alertas-leave-to {
    opacity: 0;
}

@media only screen and (max-width: 1200px) {
    .bloco-infor-dados > div {
        width: 49%;
    }
}

.el-message-box {
    width: 50%;

    .el-message-box__btns {
        width: 100%;
        display: flex;
        justify-content: flex-end;
    }

    .el-message-box__btns button:nth-child(2) {
        width: 200px !important;
    }
}
</style>
